export class PostProcess2DEffect {
    constructor() {
        this._active = true;
        this._singleton = false;
    }
    get singleton() {
        return this._singleton;
    }
    get active() {
        return this._active;
    }
    set active(value) {
        if (this._active != value) {
            this._active = value;
            if (this._owner)
                this._owner._onChangeRender();
        }
    }
}
